export default {
  titles: ['Mr', 'Mrs', 'Miss', 'Ms', 'Mx', 'Dr', 'Other']
}
